import(/* webpackMode: "eager" */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\app\\not-found.tsx");
